import { SystemStyleObject } from '@chakra-ui/react';

export const markdownCssStyle: SystemStyleObject = {
  '.markdown-body h2': {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  '.markdown-body h3': {
    fontSize: '20px',
  },
  '.markdown-body h4': {
    fontSize: '24px',
  },
  '.markdown-body ul': {
    listStyleType: 'disc',
    paddingLeft: '40px',
    marginTop: '12px',
  },
  '.markdown-body button': {
    opacity: 0.8,
    textDecoration: 'underline',
    color: 'texas.sand.100',
    cursor: 'pointer',
    _hover: { opacity: 1 },
  },
  '.markdown-body body, .markdown-body blockquote, .markdown-body dl, .markdown-body dd, .markdown-body h1, .markdown-body h2, .markdown-body h3, .markdown-body h4, .markdown-body h5, .markdown-body h6, .markdown-body hr, .markdown-body figure, .markdown-body p, .markdown-body pre':
    {
      margin: 'revert',
    },
};
